import { BaseResourceModel } from '../../models/base-resource.model';

export class TermoAcesso extends BaseResourceModel {
  constructor(
    public modelo?: string,
    public revogado?: boolean,
    public descricao?: string,
  ) {
    super();
  }

  static converteJson(json: any): TermoAcesso {
    return Object.assign(new TermoAcesso(), json);
  }

}
